// EVENT KEYS
export var REPORT_TAB_NAMES;
(function (REPORT_TAB_NAMES) {
    REPORT_TAB_NAMES["Dashboard"] = "Dashboard";
    REPORT_TAB_NAMES["Holdings"] = "Holdings";
    REPORT_TAB_NAMES["PNL"] = "Profit & Loss";
    REPORT_TAB_NAMES["TAX"] = "Tax";
    REPORT_TAB_NAMES["TRANSACTIONHISTORY"] = "Transactions";
    REPORT_TAB_NAMES["OTHER"] = "Other reports";
})(REPORT_TAB_NAMES || (REPORT_TAB_NAMES = {}));
//DISPLAY NAMES
export var REPORT_TAB_KEYS;
(function (REPORT_TAB_KEYS) {
    REPORT_TAB_KEYS["Dashboard"] = "Dashboard";
    REPORT_TAB_KEYS["Holdings"] = "Holding";
    REPORT_TAB_KEYS["PNL"] = "ProfitandLoss";
    REPORT_TAB_KEYS["TAX"] = "Tax";
    REPORT_TAB_KEYS["TRANSACTIONHISTORY"] = "Transactions";
    REPORT_TAB_KEYS["OTHER"] = "otherReports";
})(REPORT_TAB_KEYS || (REPORT_TAB_KEYS = {}));
export const ReportTabKeys = new Map([[
        REPORT_TAB_KEYS.Dashboard, {
            key: REPORT_TAB_KEYS.Dashboard, title: REPORT_TAB_NAMES.Dashboard
        }
    ], [
        REPORT_TAB_KEYS.Holdings, {
            key: REPORT_TAB_KEYS.Holdings, title: REPORT_TAB_NAMES.Holdings
        }
    ], [
        REPORT_TAB_KEYS.PNL, {
            key: REPORT_TAB_KEYS.PNL, title: REPORT_TAB_NAMES.PNL
        }
    ], [
        REPORT_TAB_KEYS.TAX, {
            key: REPORT_TAB_KEYS.TAX, title: REPORT_TAB_NAMES.TAX
        }
    ], [
        REPORT_TAB_KEYS.TRANSACTIONHISTORY, {
            key: REPORT_TAB_KEYS.TRANSACTIONHISTORY, title: REPORT_TAB_NAMES.TRANSACTIONHISTORY
        }
    ], [
        REPORT_TAB_KEYS.OTHER, {
            key: REPORT_TAB_KEYS.OTHER, title: REPORT_TAB_NAMES.OTHER
        }
    ]]);
// const REPORT_TAB_LINK: Record<REPORT_TAB_NAMES, REPORT_TAB_KEYS> = {
//     [REPORT_TAB_NAMES.Dashboard]: REPORT_TAB_KEYS.Dashboard,
//     [REPORT_TAB_NAMES.Holdings]: REPORT_TAB_KEYS.Holdings,
//     [REPORT_TAB_NAMES.PNL]: REPORT_TAB_KEYS.PNL,
//     [REPORT_TAB_NAMES.TAX]: REPORT_TAB_KEYS.TAX,
//     [REPORT_TAB_NAMES.OTHER]: REPORT_TAB_KEYS.OTHER,
// }
